var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("ELIGIBLE EXPENSES")]),_c('h4',[_vm._v("Expenses incurred in the treatment of a covered Illness or Injury which are Medically Necessary and not exceeding the limits in Schedule A - Benefit Coverage. ")])])
}]

export { render, staticRenderFns }